import type { AppointmentDetailsDto, AppointmentDto, CreateAppointmentDto, UserDto } from '../generated/model';

export type CreateAppointmentRequestDto = Omit<CreateAppointmentDto, 'from' | 'until'> & {
  date: string;
  timeFrom?: string | null;
  timeUntil?: string | null;
};

export const toGeneratedCreateAppointmentDto = (dto: CreateAppointmentRequestDto) =>
  dto as unknown as CreateAppointmentDto;

export type AppointmentResponseDto = Omit<AppointmentDto, 'from' | 'until' | 'employee'> & AppointmentResponseFields;

export type AppointmentDetailsResponseDto = Omit<AppointmentDetailsDto, 'from' | 'until' | 'employee'> &
  AppointmentResponseFields;

type AppointmentResponseFields = {
  contact?: UserDto | null;
  date?: string | null;
  employee?: UserDto | null;
  from?: string | null;
  timeFrom?: string | null;
  timeUntil?: string | null;
  until?: string | null;
};

export type AppointmentDateTimeLike = AppointmentResponseFields;

export const getAppointmentStartDateTime = (appointment?: AppointmentDateTimeLike | null) =>
  appointment?.from ?? getAppointmentDateTime(appointment?.date, appointment?.timeFrom);

export const getAppointmentEndDateTime = (appointment?: AppointmentDateTimeLike | null) =>
  appointment?.until ?? getAppointmentDateTime(appointment?.date, appointment?.timeUntil);

export const getAppointmentEndDateTimeOrStart = (appointment?: AppointmentDateTimeLike | null) =>
  getAppointmentEndDateTime(appointment) ?? getAppointmentStartDateTime(appointment);

export const getAppointmentDate = (appointment?: AppointmentDateTimeLike | null) =>
  appointment?.date ?? getDateFromDateTime(appointment?.from);

export const getAppointmentTimeFrom = (appointment?: AppointmentDateTimeLike | null) =>
  getLocalTime(appointment?.timeFrom) ?? getTimeFromDateTime(appointment?.from);

export const getAppointmentTimeUntil = (appointment?: AppointmentDateTimeLike | null) =>
  getLocalTime(appointment?.timeUntil) ?? getTimeFromDateTime(appointment?.until);

export const getAppointmentContact = (appointment?: AppointmentDateTimeLike | null) =>
  appointment?.contact ?? appointment?.employee ?? null;

function getAppointmentDateTime(date?: string | null, time?: string | null) {
  if (!date) return undefined;

  return time ? `${date}T${time}` : date;
}

function getLocalTime(time?: string | null) {
  return time ? time.slice(0, 5) : undefined;
}

function getTimeFromDateTime(dateTime?: string | null) {
  return dateTime?.includes('T') ? dateTime.slice(11, 16) : undefined;
}

function getDateFromDateTime(dateTime?: string | null) {
  return dateTime ? dateTime.slice(0, 10) : undefined;
}
